import { useEffect } from "react";

export default function useSEO({
    title,
    description,
    keywords,
    schemas = []     // schemas array passed from schemaRouter
}) {
    useEffect(() => {

        /* ===============================
           PAGE TITLE
           =============================== */
        // Update document title on route change
        if (title) {
            document.title = title;
        }

        /* ===============================
           META DESCRIPTION
           =============================== */
        // Create or update <meta name="description">
        if (description) {
            let meta = document.querySelector("meta[name='description']");

            // If meta tag doesn't exist, create it
            if (!meta) {
                meta = document.createElement("meta");
                meta.setAttribute("name", "description");
                document.head.appendChild(meta);
            }

            // Always update content
            meta.setAttribute("content", description);
        }

        /* ===============================
           META KEYWORDS
           =============================== */
        // Create or update <meta name="keywords">
        if (keywords) {
            let meta = document.querySelector("meta[name='keywords']");

            // Create if missing
            if (!meta) {
                meta = document.createElement("meta");
                meta.setAttribute("name", "keywords");
                document.head.appendChild(meta);
            }

            meta.setAttribute("content", keywords);
        }

        /* ===============================
           JSON-LD STRUCTURED DATA
           =============================== */
        // Inject structured data into <head>
        if (schemas && schemas.length > 0) {

            // Reuse ONE script tag for all schemas
            let script = document.getElementById("json-ld-schema");

            // Create script tag only once
            if (!script) {
                script = document.createElement("script");
                script.type = "application/ld+json";
                script.id = "json-ld-schema";
                document.head.appendChild(script);
            }

            /* --------------------------------
               IMPORTANT CHANGE:
               Google prefers multiple schemas
               to be wrapped in "@graph"
               instead of a raw array.
               -------------------------------- */
            const jsonLd =
                schemas.length === 1
                    ? schemas[0] // Single schema → output directly
                    : {
                        "@context": "https://schema.org",
                        "@graph": schemas // Multiple schemas → wrapped safely
                    };

            // Write JSON-LD into script tag
            script.textContent = JSON.stringify(jsonLd, null, 2);
        }

    }, [title, description, keywords, schemas]);
}
